const TRACKER_CONSTANTS = {
  ORDER_STATUS_BAR_STEPS: 4,
  ADMIN_URL_FOLIO: 'https://workspaces.sad.jelp.io/folio/'
}

export default TRACKER_CONSTANTS
